import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import WingLayout from './components/layout/WingLayout';
import HomePage from './pages/HomePage';

/* Everything past the homepage is split out. Leaflet in particular used
   to ship to every visitor even though the map only exists on one page. */
const WorkPage       = lazy(() => import('./pages/work/WorkPage'));
const ProjectsPage   = lazy(() => import('./pages/work/ProjectsPage'));
const LifePage       = lazy(() => import('./pages/life/LifePage'));
const AdventuresPage = lazy(() => import('./pages/life/AdventuresPage'));
const WritingPage    = lazy(() => import('./pages/life/WritingPage'));
const PostPage       = lazy(() => import('./pages/life/PostPage'));
const LogPage        = lazy(() => import('./pages/life/LogPage'));
const NotFoundPage   = lazy(() => import('./pages/NotFoundPage'));

/* The old routes stay addressable, so anything already shared keeps
   working. `replace` keeps them out of the back-button history. */
const LEGACY_REDIRECTS = [
  ['/thoughts',   '/life/writing'],
  ['/log',        '/life/log'],
  ['/projects',   '/work/projects'],
  ['/experience', '/work'],
];

/* /now was routed but linked from nowhere, and rendered a third layout
   over the same four files as /log. It now points at the live view. */
const LegacyNow = () => <Navigate to="/life/log?filter=current" replace />;

/* Adventure deep links carried a hash (#running, #hiking). Keep it. */
const LegacyAdventures = () => {
  const { hash } = useLocation();
  return <Navigate to={`/life/adventures${hash}`} replace />;
};

export const RouteTable = () => (
  <Suspense fallback={<div className="page container" aria-busy="true" />}>
    <Routes>
      <Route path="/" element={<HomePage />} />

      <Route element={<WingLayout wing="work" />}>
        <Route path="/work" element={<WorkPage />} />
        <Route path="/work/projects" element={<ProjectsPage />} />
      </Route>

      <Route element={<WingLayout wing="life" />}>
        <Route path="/life" element={<LifePage />} />
        <Route path="/life/adventures" element={<AdventuresPage />} />
        <Route path="/life/writing" element={<WritingPage />} />
        <Route path="/life/writing/:slug" element={<PostPage />} />
        <Route path="/life/log" element={<LogPage />} />
      </Route>

      <Route path="/adventures" element={<LegacyAdventures />} />
      <Route path="/now" element={<LegacyNow />} />
      {LEGACY_REDIRECTS.map(([from, to]) => (
        <Route key={from} path={from} element={<Navigate to={to} replace />} />
      ))}

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Suspense>
);

export default RouteTable;
